import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type RecType } from '@/defs/rec'
import { cn } from '@/utils/commonUtil'
import { formatFullNumber } from '@/utils/formatUtil'
import { getRecName } from '@/utils/recUtil'

import { StatCommonBox } from '../../StatCommon/StatCommonBox/StatCommonBox'

import styles from './StatRecRank.module.scss'

type Props = {
  isInView?: boolean
  rec: RecType
}

export const StatRecRank = ({ isInView, rec }: Props) => {
  const { rank } = rec
  const fullName = getRecName(rec)

  const variant = rank && rank <= 100 ? 'top100' : undefined

  const popover = rank !== undefined && (
    <>
      <h2>
        <IconWithLabel iconBefore='chessKing'>Rank</IconWithLabel>
      </h2>
      <p>
        <strong>{fullName}</strong> is ranked <strong>#{formatFullNumber(rank)}</strong> in popularity among all
        commanders.
      </p>
    </>
  )

  return (
    <StatCommonBox isInView={isInView} label='Rank' popover={popover}>
      {rank !== undefined && (
        <span className={cn(styles.container, { styles, variant })}>
          <span className={styles.figure}>
            <span className={styles.numberSign}>#</span>
            <span className={styles.rank}>{formatFullNumber(rank)}</span>
          </span>
        </span>
      )}
    </StatCommonBox>
  )
}
